import Head from 'next/head';
import Image from 'next/image';
import styles from '../../styles/sass/pages/Contact.module.scss'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import location1Photo from '../../../public/img/zenit_rendelo-2.JPG';
import location2Photo from '../../../public/img/negyszemkozt_rendelo.jpeg';
import CtaCard from '../../components/layout/ctaCard';

export default function AboutMe() {
    return (
        <>
            <Head>
                <title>Kapcsolat | Szabó Jennifer Pszichológus</title>
                <meta name="description" content="Pszichológiai tanácsadás személyesen Budapesten, a II. és XI. kerületben, valamint online Google Meet-en. Elérhetőségek." />
                <meta property="og:title" content="Kapcsolat | Szabó Jennifer Pszichológus" />
                <meta property="og:type" content="article" />
                <meta property="og:description" content="Pszichológiai tanácsadás személyesen Budapesten, a II. és XI. kerületben, valamint online Google Meet-en. Elérhetőségek." />
                <meta property="og:url" content="https://szabojennifer.hu/kapcsolat" />
                <meta property="og:image" content="/img/about-without-quote.jpeg" />
                <meta property="og:image:alt" content="Kapcsolat és rendelési helyszínek" />
            </Head>
            <main className={styles.page}>
                <section className={styles.container}>
                    <div className={styles.contactInfo}>
                        <h1 className={styles.contactHeading}>Kapcsolat</h1>
                        <ul className={styles.contactWebsites}>
                            <li>
                                <a target="_blank" href="mailto:kapcsolat@szabojennifer.hu">
                                    <span className='flex flex-row items-center justify-start gap-4'>
                                        <FontAwesomeIcon icon="envelope" className='w-12 inline-block' />
                                        kapcsolat@szabojennifer.hu
                                    </span>
                                </a>
                            </li>
                            <li>
                                <a target="_blank" href="https://www.instagram.com/szabojennifer_pszichologus">
                                    <span className='flex flex-row items-center justify-start gap-4'>
                                        <FontAwesomeIcon icon={['fab', 'instagram']} className='w-12 inline-block' />
                                        Instagram
                                    </span>
                                </a>
                            </li>
                            <li>
                                <a target="_blank" href="https://www.facebook.com/olvasoMagam">
                                    <span className='flex flex-row items-center justify-start gap-4'>
                                        <FontAwesomeIcon icon={['fab', 'facebook']} className='w-12 inline-block' />
                                        Facebook
                                    </span>
                                </a>
                            </li>
                            <li>
                                <a target="_blank" href="https://www.linkedin.com/in/jennifer-szab%C3%B3-3aba52156/">
                                    <span className='flex flex-row items-center justify-start gap-4'>
                                        <FontAwesomeIcon icon={['fab', 'linkedin']} className='w-12 inline-block' />
                                        LinkedIn
                                    </span>
                                </a>
                            </li>
                            <li>
                                <span className='flex flex-row items-center justify-start gap-4'>
                                    <FontAwesomeIcon icon={['fab', 'google']} className='w-12 inline-block' />
                                    Online konzultáció (Google Meet)
                                </span>
                            </li>
                        </ul>
                    </div>
                    <div className={styles.locationsContainer}>
                        <article className={styles.locationCard}>
                            <div className={styles.locationImageContainer}>
                                <Image
                                    src={location1Photo}
                                    alt="Zenit Pszichoterápiás Központ"
                                    className={styles.locationImage}
                                    fill
                                    sizes="(max-width: 704px) 100vw, (max-width: 1200px) 50vw, 33vw"
                                />
                            </div>
                            <div className={styles.locationBadge}>
                                <FontAwesomeIcon icon="fa-map-marker-alt" className={styles.locationBadgeIcon} />
                                Személyes konzultáció
                            </div>
                            <h2 className={styles.locationTitle}>Zenit Pszichoterápiás Központ</h2>
                            <p className={styles.locationAddress}>Budapest, II. kerület Alkotás utca 11.</p>
                            <a
                                className={styles.locationLink}
                                href="https://www.google.com/maps/search/?api=1&query=Budapest%2C%20Alkot%C3%A1s%20utca%2011"
                                target="_blank"
                                rel="noopener noreferrer"
                            >
                                ÚTVONALTERVEZÉS
                            </a>
                        </article>

                        <article className={styles.locationCard}>
                            <div className={styles.locationImageContainer}>
                                <Image
                                    src={location2Photo}
                                    alt="Négyszemközt Pszichológiai Műhely"
                                    className={styles.locationImage}
                                    fill
                                    sizes="(max-width: 704px) 100vw, (max-width: 1200px) 50vw, 33vw"
                                />
                            </div>
                            <div className={styles.locationBadge}>
                                <FontAwesomeIcon icon="fa-map-marker-alt" className={styles.locationBadgeIcon} />
                                Személyes konzultáció
                            </div>
                            <h2 className={styles.locationTitle}>Négyszemközt Pszichológiai Műhely</h2>
                            <p className={styles.locationAddress}>Budapest, XI. kerület Budafoki út 34b.</p>
                            <a
                                className={styles.locationLink}
                                href="https://www.google.com/maps/search/?api=1&query=Budapest%2C%20Budafoki%20%C3%BAt%2034b"
                                target="_blank"
                                rel="noopener noreferrer"
                            >
                                ÚTVONALTERVEZÉS
                            </a>
                        </article>
                    </div>
                </section>

                <CtaCard />
            </main>
        </>
    )
}